import { call, put } from 'redux-saga/effects';
import {
    filterSolventsError,
    filterSolventsSuccess
} from '../../actions/solvents.actions';
import api from '../../../services/api';
import { dialog } from '../../../components/UI';

export default function* filterSolvents(action) {
    const loading = dialog({
        type: 'loading',
        i18nKey: 'wait',
        instantShow: false
    });
    loading.show();
    try {
        const { callback } = action.payload;
        const ids = action.payload.ids.join(',');
        const { data } = yield call(api.get, `/solvents?limit=100&ids=${ids}`);
        if (data.object) {
            yield put(
                filterSolventsSuccess({ solvents: data.object, message: '' })
            );
            if (callback) {
                callback(data.object[0]);
            }
        } else {
            yield put(
                filterSolventsSuccess({
                    solvents: [],
                    message: data.messages.warnings[0]
                })
            );
            if (callback) {
                callback(data.object[0]);
            }
        }
    } catch (err) {
        yield put(filterSolventsError());
    }
    loading.close();
}
